import { JSX } from 'react'
import type { SchoolType } from '../models/account/school/pending-school-account.modl'

export type { SchoolType }

/**
 * 学校種別（公立・私立・国立）を日本語ラベルに変換
 * @param schoolType - 学校種別 ('public' | 'private' | 'national')
 * @returns 日本語ラベル
 */
export const getSchoolTypeLabel = (schoolType: SchoolType | string): string => {
  switch (schoolType) {
    case 'public':
      return '公立'
    case 'private':
      return '私立'
    case 'national':
      return '国立'
    default:
      return typeof schoolType === 'string' ? schoolType : ''
  }
}

/** フォーム等で使う学校種別の選択肢 */
export const SCHOOL_TYPE_OPTIONS: { value: SchoolType; label: string }[] = [
  { value: 'public', label: '公立' },
  { value: 'private', label: '私立' },
  { value: 'national', label: '国立' },
]

interface SchoolTypeBadgeProps {
  schoolType: SchoolType | string
}

/**
 * 学校種別バッジコンポーネント
 * 公立・私立・国立をバッジ形式で表示
 */
export const SchoolTypeBadge = ({ schoolType }: SchoolTypeBadgeProps): JSX.Element => {
  const getStyle = () => {
    switch (schoolType) {
      case 'public':
        return { backgroundColor: '#e3f2fd', color: '#1565c0' }
      case 'private':
        return { backgroundColor: '#f3e5f5', color: '#7b1fa2' }
      case 'national':
        return { backgroundColor: '#e8f5e9', color: '#2e7d32' }
      default:
        return { backgroundColor: '#f5f5f5', color: '#616161' }
    }
  }

  const style = getStyle()

  return (
    <span
      style={{
        display: 'inline-block',
        padding: '2px 6px',
        borderRadius: '3px',
        fontSize: '0.65rem',
        fontWeight: 500,
        lineHeight: '1.2',
        ...style,
        whiteSpace: 'nowrap',
      }}
    >
      {getSchoolTypeLabel(schoolType)}
    </span>
  )
}
